import { render, staticRenderFns } from "./FormRecipientsTypePage.vue?vue&type=template&id=6e2d9ffb&scoped=true&"
import script from "./FormRecipientsTypePage.vue?vue&type=script&lang=js&"
export * from "./FormRecipientsTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d9ffb",
  null
  
)

export default component.exports